import { IIssueGroupOverviewResponse } from '@kcftech/prometheus-client';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export function useTreeItemIssueCount(
    groupId: string,
    isDynamicSystem: boolean,
    options?: UseQueryOptions<IIssueGroupOverviewResponse | undefined>,
) {
    return useQuery({
        queryKey: ['group-issue-count', groupId],

        queryFn: async () =>
            sdClient.getIssueGroupOverview({
                groupId,
                includeChildren: !isDynamicSystem,
            }),

        ...options,
    });
}
